<!-- 试题展示 -->
<template>
    <li class="question-view">
        <!-- 渲染题干 -->
        <div class="stem" :class="{'is--required': question.required}">{{ stemStr }}</div>
        <!-- 备注 -->
        <div class="remark" v-text="question.remark" v-if="question.remark"/>
        <!-- 渲染单选，多选的选项 -->
        <template v-if="[QUESTION_VAL.single, QUESTION_VAL.multiple].includes(question.type)">
            <el-radio-group v-if="question.type === QUESTION_VAL.single" v-model="question.answer">
                <el-radio
                    v-for="(option, i) in question.options"
                    class="stem-options"
                    :key="`options-radio${i}`"
                    :label="numberToWord(i + 1)"
                    :disabled="!isDo">
                    <span class="stem-options--text" v-if="option.type === 'text'">{{ option.text }}</span>
                    <img
                        :src="option.text"
                        width="600px"
                        height="100px"
                        v-if="option.type === 'image'" alt="stem-options"/>
                </el-radio>
            </el-radio-group>
            <el-checkbox-group v-else v-model="question.answer">
                <el-checkbox
                    v-for="(option, i) in question.options"
                    class="stem-options"
                    :key="`options-checkbox${i}`"
                    :label="numberToWord(i + 1)"
                    :disabled="!isDo">
                    <span class="stem-options--text" v-if="option.type === 'text'">{{ option.text }}</span>
                    <img
                        :src="option.text"
                        width="600px"
                        v-if="option.type === 'image'" alt="stem-options"/>
                </el-checkbox>
            </el-checkbox-group>
        </template>
        <!-- 渲染填空-->
        <template v-else-if="[QUESTION_VAL.filling].includes(question.type)">
            <el-input type="textarea"
                      v-model="question.answer"
                      :autosize="{ minRows: 4 }"
                      class="filling-textarea--do" v-if="mode === 'do'"/>
            <div v-else class="filling-textarea--view" v-text="question.answer"/>
        </template>
        <div class="error-tips"
             v-if="isShowErrorTip">{{[QUESTION_VAL.single, QUESTION_VAL.multiple].includes(question.type) ? "请选择" : "请填写"}}</div>
    </li>
</template>

<script>
import { QUESTION_VAL } from "@/utils/question-config"
import { numberToWord } from "@/utils"

export default {
    name: "QuestionView",
    props: {
        question: {
            type: Object,
            default() {
                return {}
            }
        },
        number: {
            type: [Number, String],
            default () {
                return ""
            }
        },
        // 模式 有三种模式，查看和做题编辑
        mode: {
            type: String,
            default: "view",
            validator(mode) {
                return ["view", "do"].includes(mode)
            }
        },
    },
    data() {
        return {
            QUESTION_VAL: Object.freeze(QUESTION_VAL),
            checkBox: [],
            isShowErrorTip: false
        }
    },
    watch: {
        "question.answer" (val) {
            if (this.question.required && this.isDo) {
                if (Array.isArray(val)) {
                    this.isShowErrorTip = !val.length
                } else {
                    this.isShowErrorTip = !val
                }
            }
        }
    },
    computed: {
        stemStr({ number, question, isQuestion }) {
            const { stem, text } = question
            return `${number ? `${number}、` : ""}${text && isQuestion ? `[${text}] ` : ""} ${stem}`
        },
        // 是否处于做题状态
        isDo({ mode }) {
            return mode === "do"
        },
        // 是否是问卷试题
        isQuestion({ question }) {
            return Object.values(QUESTION_VAL).includes(question.type)
        },
    },
    methods: {
        numberToWord,
        setErrorTip (value) {
            this.isShowErrorTip = value
        }
    }
}
</script>

<style scoped lang="less">
.remark {
    margin: 10px 0;
    font-size: 15px;
}

.question-view {
    padding: 20px 30px;
}

.stem {
    font-size: 17px;
    font-weight: 500;
    margin: 10px 0;
    box-sizing: border-box;
    word-break: break-all;
    position: relative;
    &.is--required::before {
        content: "*";
        color: #E62129;
        position: absolute;
        left: -10px;
    }
}

.stem-options {
    padding: 10px 30px;
    display: flex;
    align-items: center;

    &--text {
        color: #606266;
        font-size: 14px;
    }
}

.filling-textarea--view {
    border: 1px solid #BABFCB;
    min-height: 90px;
    margin-top: 30px;
    overflow: hidden;
    margin-left: 30px;
    margin-right: 30px;
    box-sizing: border-box;
    font-size: 16px;
    padding: 10px 0;
}

.filling-textarea--do, .filling-textarea--view {
    margin-bottom: 30px;
    padding-left: 30px;
    padding-right: 30px;
}
.error-tips {
    font-size: 16px;
    padding-left: 30px;
    color: #E62129;
}
::v-deep {
    .el-radio__input.is-disabled .el-radio__inner, .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        border-color: #409eff;
        &::after {
            border-color: #409eff;
        }
    }
    .el-radio__input.is-disabled .el-radio__inner::after {
        background-color: #409eff;
    }
}
</style>
